import { useEffect, useState } from "react";
import { connect } from "react-redux";
import WorkoutCard from "./../SubComponents/WorkoutCard";

import BannerRestDay from "../SubComponents/BannerRestDay";
import BannerYourDay from "../SubComponents/BannerYourDay";
import useDate from "../../../hooks/useDate";

import { GetNextWorkout } from "../../../redux/v2/user/actions";
import moment from "moment";

function YourDayBanner(props) {
    const { GetMonthDates, GetWeekDetails } = useDate();
    const { selectedDate, workoutPlan, calendar } = props;
    const { workoutHistory, account } = props.User;
    const { programs, workouts } = props.Program;

    const [program, setProgram] = useState(null);
    const [workout, setWorkout] = useState(null);
    const [pointDate, setPointDate] = useState(null);
    const [selectedDateL, setSelectedDateL] = useState(selectedDate);

    const { year, month, day } = GetMonthDates(new Date());
    const { dayPosition, weekPosition, dayOrder } = GetWeekDetails(new Date, pointDate);
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];
    useEffect(() => {
        setSelectedDateL(selectedDate);
    }, [selectedDate]);

    useEffect(() => {
        if (onboardingDetail?.created_at) {
            setPointDate(onboardingDetail?.created_at);
        }

    }, [onboardingDetail?.created_at]);


    useEffect(() => {
        const cb = async () => {
            if (workoutPlan) {
                setWorkout(null);
                const sd = selectedDate || { year, month, day, dayPosition, dayOrder };
                let calendarDates = [];
                for (let x = 0; x < calendar?.calendar?.length; x++) {
                    calendarDates = [...calendarDates, ...calendar?.calendar[x]];
                }
                let scheduledProgram = calendarDates?.find((c) => c?.day == sd?.day && c?.month == sd?.month && c?.year == sd?.year);
                scheduledProgram = scheduledProgram?.schedule?.program || null;

                setProgram(scheduledProgram);
                setSelectedDateL(sd);
                if (scheduledProgram?.id) {

                    const previousWorkoutIDs = [];
                    for (let x = 0; x < workoutHistory?.length; x++) {
                        if (workoutHistory[x]?.program_id == scheduledProgram?.id) {
                            previousWorkoutIDs.push(workoutHistory[x]?.workout_id);
                        }
                    }

                    const res = await props.GetNextWorkout(scheduledProgram?.id, previousWorkoutIDs, scheduledProgram?.occurence);
                    setWorkout(res);
                }

            }
        };

        cb();
    }, [selectedDate, workoutPlan]);

    const mDate = moment(`${selectedDateL?.year}/${selectedDateL?.month}/${selectedDateL?.day}`);
    let isBeyondSchedule = mDate.isAfter(moment(`${calendar?.endDate?.year}/${calendar?.endDate?.month}/${calendar?.endDate?.day}`));

    return (
        <div id="your-day-banner">
            <div id="your-day-banner-wrapper" className="flex-c">
                {
                    (program?.id && !isBeyondSchedule)
                        ? <BannerYourDay program={program} workout={workout} selectedDate={selectedDateL} />
                        : <BannerRestDay workoutPlan={workoutPlan} selectedDate={selectedDateL} calendar={calendar} />
                }
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
    Program: state.Program,
});

export default connect(mapStateToProps, {
    GetNextWorkout,
})(YourDayBanner);